import Vue from 'vue'

import router from './router'
import App from './App.vue'

import axios from 'axios'
import storage from './utils/storage'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

//element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


import echarts from 'echarts'

import moment from 'moment'; //导入模块
moment.locale('zh-cn'); //设置语言 或 moment.lang('zh-cn'); 
Vue.prototype.$moment = moment;//赋值使用

import globalFunc from './utils/global_func'
Vue.use(globalFunc);

//Vue.use(VueRouter)
Vue.config.productionTip = false

Vue.prototype.$echarts = echarts

//配置全局的axios的使用
axios.defaults.baseURL = process.env.VUE_APP_BASE_API
axios.defaults.headers.common['Authorization'] = 'TESTUSER' ;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded' ; 
axios.defaults.headers['Access-Control-Allow-Origin'] = '*';

axios.interceptors.request.use(config => {
  var token = localStorage.getItem("token") || "";
  if(token == "") throw 0;

  config.headers.Authorization = token;
  return config
}, error => {
  app.$message({type:"error",message:"服务器请求错误：" + error.message});
});

axios.interceptors.response.use(response => {
  if(!response) return;
  var data = response.data || {code:'-9999', description:'无结果返回'};
  if (data.code == '0') {
    console.log("正常获取数据" + data.description)
  }
  else
  {
    app.$message({type:"error",message:"返回错误：" + data.code + "=>" + data.description});
  }
  return response
}, error => {
  app.$message({type:"error",message:"服务器响应错误：" + error.message});
});

var app = new Vue({
  el: '#app',
  router,
  render: h => h(App),
}).$mount('#app')
